/* 🤖 this file was generated by svg-to-ts */
export const matIconEyeglasses: {
  name: 'eyeglasses';
  data: string;
} = {
  name: 'eyeglasses',
  data: `<svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48"><path d="M268 716q35 0 63.5-21.5T373 638l15-44q21-59-6-108.5T302 436H139l21 183q5 42 35.5 69.5T268 716Zm424 0q42 0 72.5-28t35.5-70l21-182H659q-53 0-80 49.5T572 595l15 43q12 35 41 56.5t64 21.5Zm-423 60q-65 0-112.5-43T101 624L78 436H40v-60h259q40 0 76.5 22.5T438 462h85q26-41 62.5-63.5T662 376h258v60h-38l-23 188q-8 66-55.5 109T691 776q-53 0-97-32t-64-86l-15-41q-3-9-5.5-20t-4.5-25h-50q-2 13-4.5 23.5T445 615l-15 42q-20 54-64 86.5T269 776Z"/></svg>`
};
